import { useState } from 'react';
import { Button } from './ui';
import ClickerEvidenceModal from './ClickerEvidenceModal';
import { auditEvidenceId } from './auditData';

export interface Props {
  data: string;
  className?: string;
}

// Renders an audit event's payload and, when the event points at clicker
// evidence, a button that opens it.
export default function AuditDataCell({ data, className }: Props) {
  const [open, setOpen] = useState(false);
  const evidenceId = auditEvidenceId(data);

  if (!data || data.length === 0) {
    return <span className="text-text-3">—</span>;
  }
  return (
    <div className="flex items-start gap-2 min-w-0">
      <span className={className || 'text-[11.5px] text-text-2 font-mono break-all'}>{data}</span>
      {evidenceId !== null && (
        <>
          <Button size="sm" variant="ghost" className="shrink-0" onClick={() => setOpen(true)}>
            Evidence
          </Button>
          {open && <ClickerEvidenceModal evidenceId={evidenceId} onClose={() => setOpen(false)} />}
        </>
      )}
    </div>
  );
}
